import React from "react";
import classes from "./Header.scss";
import { ToddleIcon } from "SvgComponents";
import { Button } from "@toddle-edu/ds-web";
import { ChevronLeftOutlined } from "@toddle-edu/ds-icons";

const Header = props => {
  const { onClickCreateStandard, goToBack } = props;
  return (
    <div className={classes.container}>
      <div className={classes.leftContainer}>
        <div className={classes.leftIcon} onClick={goToBack}>
          <ChevronLeftOutlined />
        </div>
        <div className={classes.logoIcon}>
          <ToddleIcon />
        </div>
        <div className={classes.headerTitleContainer}>{"Manage Standard"}</div>
      </div>
      <div className={classes.rightContainer}>
        <Button variant={"primary"} onClick={onClickCreateStandard}>
          {"Create new standard"}
        </Button>
      </div>
    </div>
  );
};

export default Header;
